<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';

	import { switchToOptimism } from '$lib/wallet/wallet';
</script>

<GradientBorder
	gradient="bg-fx-gradient-19"
	paddingClass="p-px"
	borderRadius="rounded-lg squircle-lg"
	outerClassList="h-full"
	innerClassList="bg-fx-grey-800 flex justify-center items-center"
>
	<div
		class="px-3 py-1 text-fx-grey-100 font-medium rounded-lg squircle-lg flex gap-2 cursor-pointer"
		on:click={switchToOptimism}
		on:keydown={switchToOptimism}
		role="presentation"
	>
		Switch to <img src={'optimism.svg'} loading="lazy" alt="op" class="w-5 h-5" />
	</div>
</GradientBorder>
